exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/_wks-ext.js
// module id = +zvd
// module chunks = 0 3